import {Suspense} from 'react';
import {Segmented} from "antd";
import {CreatorGroupBy, groupByAtom, pageAtom} from "./atoms";
import {useAtom} from "jotai";
import Creators from "./Creators";
import {PageLoading} from "@ant-design/pro-layout";
import {PageContainer} from "@ant-design/pro-components";
import {IG_COLOR, TT_COLOR, YT_COLOR} from "../../../common/constants";
import {InstagramOutlined, TikTokOutlined, UserOutlined, YoutubeFilled} from "@ant-design/icons";

type Props = {};

export const CreatorsWrapper = (props: Props) => {

    
    return (
        <PageContainer>
            
            <Suspense fallback={<PageLoading/>}>
                <Creators/>
            </Suspense>

        </PageContainer>
    );
};

export default CreatorsWrapper;